import * as d3 from 'd3-selection'

export default function (dimensions, fontSize) {

  var draw = function (selection) {
    selection.each(function (data) {
      let score = d3.select(this)
                    .selectAll('g.score')
                    .data(function (d) {
                      return d.fields && d.fields[0] ? [d.fields[0]] : []
                    })
        , enter = score.enter()
                       .append('g')
                         .attr('class', 'score')
        , _score = enter.merge(score)
                        .attr('transform', 'translate(0, ' + dimensions.labelHeight + ')')
                        .selectAll('text')
                        .data(d => [d])
                        .join('text')
                        .attr('font-size', fontSize)
                        .attr('text-anchor', 'middle')
                        .classed('bottom-label', true)

      score.exit().remove()

      var _tspans = _score.selectAll('tspan')
                          .data(function (d) {
                            return [d.label, d.formatted]
                          })
        , tspans = _tspans.enter()
                          .append('tspan')
                          .merge(_tspans)

        tspans.text(String)
              .filter(function (d, i) {
                return i === 0
              })
              .attr('dy', '1em') // sets a decent baseline because IE can't do it in CSS

        tspans.text(String)
              .filter(function (d, i) {
                return i === 1
              })
              .attr('dx', '.3em')

      if (_score.node()) {
        dimensions.labelHeight += _score.node().getBBox().height
      }
    })
  }

  return draw
}
